import React, { CSSProperties } from 'react';
import {HealthStatusSummaryDisplay} from './HealthStatusDisplay'
import {HealthData} from './HealthStatusDisplay'
import {UserInvestigationInfo} from './UserInvestigationDisplay'
import {InvestigationInterface} from './InvestigationDisplay'

import ExpertSettingsButton, { SuppressedAlertsInterface } from './ExpertSettingsDisplay'
import { AuthenticationInterface } from './AuthenticationDisplay'
import { LaneDisplayInterface } from './PrimaryDisplay'
import {CurrentCountAndDoseDisplay,
        CurrentNeutronCountDisplay,
        AcknowledgeAlertInterface,
        AlertAcknowledgeDisplay,
        CurrentGPSStatusDisplay,
        TimeDisplay,
        CurrentPCSDisplay,
        CurrentDiskStatusDisplay} from './StatusComponents'

import * as messages from '@radnuc/messages';


import './MetricsDisplay.css';
import './StatusHeader.css';

import Config from './Config';

type Investigation = messages.Encounter.Encounter | messages.Rad.Investigation;
type PCSResult = messages.Rad.PCSResult;

const Title: React.FC<{ title: string }> = (props) => {
    return (
        <label className="Title">{props.title}</label>
    )
}
const Subtitle: React.FC<{ subtitle: string }> = (props) => {
    return (
        <label className="Subtitle">{props.subtitle}</label>
    )
}

const ConnectionStatus: React.FC<{ connected: boolean }> = (props) => {
    return (
        <div className={"ConnectionStatus StatusBox " + (props.connected ? "connected" : "disconnected")}>
            <span className="value">{props.connected ? 'Connected' : 'Disconnected'}</span>
        </div>
    )
}


interface StatusHeaderProps {
    connected: boolean,
    currentPCSResult: PCSResult | null,
    radiationData?: messages.Rad.RadiationReading[] | null,
    neutronData?: messages.Rad.NeutronReading[] | null,
    positions?: messages.Core.GPSReading[] | null,
    investigationsNotAcknowledged?: Investigation[];
    //investigationInterface?: AcknowledgeAlertInterface,
    investigationInterface?: InvestigationInterface,
    alertAcknowledge?: boolean,
    authenticationInterface?: AuthenticationInterface,
    userInvestigationInfo?: UserInvestigationInfo,
    laneDisplayInterface?: LaneDisplayInterface,
    defaultDoseRateAlarmThresh?: number,
    healthData: Map<number,HealthData>,
    config: Config,
    liveStream: boolean,
    replayTime?: Date,
    isPrimary?: boolean,
    isCommercial?: boolean,
    hideDoseRateAlarmSettings?: boolean,
    showPCSLRTSettings?: boolean,
    headerTitle?: string,
    headerSubtitle?: string,
    suppressedAlertsInterface?: SuppressedAlertsInterface,
    uiVersionString?: string,
}
interface StatusHeaderState { }
export class StatusHeader extends React.Component<StatusHeaderProps, StatusHeaderState> {

    render() {

        let ui_title:string = '';
        if(this.props.headerTitle === undefined){
            if(this.props.isPrimary){
                ui_title += 'Primary'
            } else {
                ui_title += 'Secondary'
            }
            if(this.props.isCommercial){
                ui_title += ' COV'
            } else {
                ui_title += ' POV'
            }
        } else {
            ui_title = this.props.headerTitle;
        }


        let currentCountAndDoseDisplay;
        let currentNeutronCountDisplay;
        let currentGPSStatusDisplay;
        let acknowledgeAlertDisplay;
        let timeDisplay;

        const acknowlegeAlertInterface = this.props.investigationInterface as AcknowledgeAlertInterface;

        if(this.props.radiationData !== undefined && !this.props.isPrimary)
            currentCountAndDoseDisplay = <CurrentCountAndDoseDisplay radiationData={this.props.radiationData} healthData={this.props.healthData.get(messages.Rad.HealthComponent.RAD)}/>
        if(this.props.neutronData !== undefined && !this.props.isPrimary)
            currentNeutronCountDisplay = <CurrentNeutronCountDisplay neutronData={this.props.neutronData} healthData={this.props.healthData.get(messages.Rad.HealthComponent.NEUTRON)}/>
        if(this.props.positions !== undefined && !this.props.isPrimary)
            currentGPSStatusDisplay = <CurrentGPSStatusDisplay position={this.props.positions} healthData={this.props.healthData.get(messages.Rad.HealthComponent.GPS)}/>
        if(this.props.investigationsNotAcknowledged !== undefined && this.props.investigationInterface)
            acknowledgeAlertDisplay = <AlertAcknowledgeDisplay investigationsNotAcknowledged={this.props.investigationsNotAcknowledged} acknowledgeAlertInterface={acknowlegeAlertInterface}/>
        if(this.props.isPrimary){
            timeDisplay= <TimeDisplay liveStream={this.props.liveStream} replayTime={this.props.replayTime} style={{width:'190px',marginTop:'5px',marginBottom:'5px'}}/>
        }

        let titleDisplay=<Title title={ui_title} />
        if(this.props.headerSubtitle){
            titleDisplay =
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <Title title={ui_title} />
                    <Subtitle subtitle={this.props.headerSubtitle}/>
                </div>
        }


        return (
            <div className="StatusHeader">
                <div className="header-left" style={{display: 'flex', flexDirection: 'row', height: '65px'}}>
                <div className="logo"></div>
                    {titleDisplay}
                    <CurrentPCSDisplay currentPCSResult={this.props.currentPCSResult} healthData={this.props.healthData.get(messages.Rad.HealthComponent.PCS)}/>
                    {currentCountAndDoseDisplay}
                    {currentNeutronCountDisplay}
                    {currentGPSStatusDisplay}
                    <CurrentDiskStatusDisplay healthData={this.props.healthData.get(messages.Rad.HealthComponent.LOG)}/>
                    {timeDisplay}
                </div>
                <div className="header-right" style={{display: 'flex', flexDirection: 'row', height: '65px'}}>
                    {acknowledgeAlertDisplay}
                    <ExpertSettingsButton acknowledgeAlert={this.props.alertAcknowledge}
                        acknowlegeAlertInterface={acknowlegeAlertInterface}
                        investigationInterface={this.props.investigationInterface}
                        authenticationInterface={this.props.authenticationInterface}
                        userInvestigationInfo={this.props.userInvestigationInfo}
                        laneDisplayInterface={this.props.laneDisplayInterface}
                        defaultDoseRateAlarmThresh={this.props.defaultDoseRateAlarmThresh}
                        hideDoseRateAlarmSettings={this.props.hideDoseRateAlarmSettings}
                        config={this.props.config}
                        isPrimary={this.props.isPrimary}
                        isCommercial={this.props.isCommercial}
                        suppressedAlertsInterface={this.props.suppressedAlertsInterface}
                        showPCSLRTSettings={this.props.showPCSLRTSettings}
                        uiVersionString={this.props.uiVersionString}/>
                    <ConnectionStatus connected={this.props.connected}/>
                    <HealthStatusSummaryDisplay healthData={this.props.healthData} isPrimary={this.props.isPrimary}/>
                </div>
            </div>
        )
    }
}

export default StatusHeader
